'use strict';

var React = require('react');
var withStyles = require('../../../node_modules/@material-ui/core/styles/withStyles.js');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    headerBackground: {
      background: theme.palette.background.main
    },
    tableHeader: {
      paddingTop: 8,
      paddingBottom: 8,
      paddingRight: 8
    }
  };
};

var LineItemHeader = function LineItemHeader(_ref) {
  var classes = _ref.classes,
      isMaterialItems = _ref.isMaterialItems,
      settings = _ref.settings;
  var show_quantity_and_unit_price = settings.show_quantity_and_unit_price,
      show_amount = settings.show_amount;
  var headerWidth = 60;
  if (!show_quantity_and_unit_price) headerWidth += 24;
  if (!show_amount) headerWidth += 16;
  return React__default["default"].createElement("tr", {
    className: classes.headerBackground
  }, React__default["default"].createElement("th", {
    className: classes.tableHeader,
    style: {
      width: headerWidth + '%',
      paddingLeft: 8
    }
  }, React__default["default"].createElement(Typography, {
    variant: "subtitle2",
    align: "left"
  }, isMaterialItems ? 'Materials' : 'Services')), show_quantity_and_unit_price && React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement("th", {
    className: classes.tableHeader,
    style: {
      width: '8%'
    }
  }, React__default["default"].createElement(Typography, {
    variant: "subtitle2",
    align: "right"
  }, "Quantity")), React__default["default"].createElement("th", {
    className: classes.tableHeader,
    style: {
      width: '16%'
    }
  }, React__default["default"].createElement(Typography, {
    variant: "subtitle2",
    align: "right"
  }, "Unit price"))), show_amount && React__default["default"].createElement("th", {
    className: classes.tableHeader,
    style: {
      width: '16%'
    }
  }, React__default["default"].createElement(Typography, {
    variant: "subtitle2",
    align: "right"
  }, "Amount")));
};

var LineItemHeader$1 = withStyles(styles)(LineItemHeader);

module.exports = LineItemHeader$1;
